import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';

function Fallback() {
  const token = localStorage.getItem("id_token");
  return (
    <Result
      className="p-bottom-0"
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        token ? (
          <Link to="/dashboard">
            <Button type="primary">Go to Dashboard</Button>
          </Link>
        ) : (
          <Link to="/">
            <Button type="primary">Back Home</Button>
          </Link>
        )
      }
    />
  );
}
export default Fallback;
